import {
    SHARE_ON_EMAIL,
    SHARE_ON_FACEBOOK,
    SHARE_ON_FACEBOOK_MESSENGER,
    SHARE_ON_TWITTER,
} from '@eb/eds-share-box';

import {
    CATEGORY_FILTER,
    FORMAT_FILTER,
    PRICE_FILTER,
    DATE_FILTER,
    QUERY_FILTER,
    LANGUAGE_FILTER,
    CURRENCY_FILTER,
    SPECIAL_FILTER,
} from './filters';

/****************************** GA CONSTANTS ********************************/

export const CITY_BROWSE_SECTION = 'cityBrowse';
export const SEARCH_SECTION = 'search';
export const ONLINE_BROWSE_SECTION = 'onlineBrowse';
export const ONLINE_SEARCH_SECTION = 'onlineSearch';

export const SEARCH_EVENT_NAVIGATION = 'search.event';

export const GA_CITY_BROWSE_CATEGORY = 'city-browse';
export const GA_SEARCH_CATEGORY = 'search';
export const GA_CATEGORY_MAP = {
    cityBrowse: GA_CITY_BROWSE_CATEGORY,
    search: GA_SEARCH_CATEGORY,
};

export const GA_TERM_MAP = {
    cityBrowse: 'citybrowse',
    search: 'destsearch',
};

export const GA_SEARCH_EVENT_CARD_CATEGORY = 'eventcard-search';
export const GA_CB_EVENT_CARD_CATEGORY = 'eventcard-cb';
export const GA_EVENT_CARD_CATEGORY_MAP = {
    cityBrowse: GA_CB_EVENT_CARD_CATEGORY,
    search: GA_SEARCH_EVENT_CARD_CATEGORY,
};

export const GA_VIEW_EVENT_ACTION = 'ViewEvent';
export const GA_EXTERNAL_VIEW_EVENT_ACTION = 'ViewExternal';
export const GA_VIEW_ARTICLE_ACTION = 'ViewArticle';
export const GA_VIEW_PROMOTED_EVENT_ACTION = 'ViewEventPromoted';
export const GA_LOCATION_CHANGE_ACTION = 'LocChange';
export const GA_VIEW_MORE_ACTION = 'ViewMore';
export const GA_SCROLL_DEPTH_ACTION = 'ScrollDepth';
export const GA_VIEW_CATEGORY_ACTION = 'ViewCategory';
export const GA_VIEW_NEARBY_CITY_ACTION = 'ViewNearbyCity';
export const GA_SAVE_EVENT_ACTION = 'Bookmark';
export const GA_UNSAVE_EVENT_ACTION = 'Unbookmark';
export const GA_SHARE_ATTEMPT_ACTION = 'ShareAttempt';
export const GA_SHARE_ACTION = 'Share';
export const GA_CHANGE_PAGE_ACTION = 'ChangePage';
export const GA_CATEGORY_FILTER_ACTION = 'CategoryFilter';
export const GA_EVENT_TYPE_FILTER_ACTION = 'EventTypeFilter';
export const GA_PRICE_FILTER_ACTION = 'PriceFilter';
export const GA_DATE_FILTER_ACTION = 'DateFilter';
export const GA_RUN_SEARCH_ACTION = 'RunSearch';
export const GA_CURRENCY_FILTER_ACTION = 'CurrencyFilter';
export const GA_LANGUAGE_FILTER_ACTION = 'LanguageFilter';
export const GA_FOLLOWED_ORGANIZERS_FILTER = 'FollowedOrganizersFilter';
export const GA_VIEW_TRENDING_SEARCH_ACTION = 'TrendingSearch';
export const GA_VIEW_ALL_TRENDING_SEARCHES_ACTION = 'AllTrendingSearches';
export const GA_VIEW_EVENT_AUTOCOMPLETE = 'ViewEventAutocomplete';
export const GA_REDO_FROM_MAP = 'RedoFromMap';
export const GA_ENTER_MAP_VIEW = 'EnterMapView';
export const GA_VIEW_EVENT_MAP_VIEW = 'ViewEventMapView';
export const GA_SEARCH_TAG_CLICK_ACTION = 'SearchTagClick';
export const GA_SEARCH_TAG_CLEAR_ACTION = 'SearchTagClear';
export const GA_MORE_FILTERS_PANEL_ACTION = 'MoreFiltersPanel';
export const GA_MORE_FILTERS_CLEARED_ACTION = 'MoreFiltersCleared';
export const GA_CREATE_COLLECTION_VIEW_ACTION = 'CreateCollectionAttempt';
export const GA_ADD_TO_COLLECTION_SHOW_ACTION = 'AddToCollectionListShown';
export const GA_SCROLL_COLLECTIONS_ACTION = 'ScrollCollections';
export const GA_CLICK_VIEW_COLLECTION_ACTION = 'ViewCollection';
export const GA_FOLLOWED_ORGANIZERS_FILTER_ATTEMPT =
    'FollowedOrganizersFilterAttempt';
// this is not an actual action, but it's used in analytics logging in the same place where the above actions are used
export const GA_PAGE_LOAD_ACTION = 'PageLoad';

export const GA_SCROLL_COMPLETE_LABEL = '100';
export const GA_SCROLL_NA_LABEL = 'N/A';

const GA_TWITTER_IDENTIFIER = 'tw';
const GA_FACEBOOK_IDENTIFIER = 'fb';
const GA_FACEBOOK_MESSENGER_IDENTIFIER = 'fbm';
const GA_EMAIL_IDENTIFIER = 'em';
const GA_COPY_IDENTIFIER = 'cp';

export const SHARE_BY_COPY = 'copy';
export const SHARE_TYPE_GA_MAP = {
    [SHARE_ON_EMAIL]: GA_EMAIL_IDENTIFIER,
    [SHARE_ON_FACEBOOK]: GA_FACEBOOK_IDENTIFIER,
    [SHARE_ON_FACEBOOK_MESSENGER]: GA_FACEBOOK_MESSENGER_IDENTIFIER,
    [SHARE_ON_TWITTER]: GA_TWITTER_IDENTIFIER,
    [SHARE_BY_COPY]: GA_COPY_IDENTIFIER,
};

export const FILTER_TYPE_GA_MAP = {
    [CATEGORY_FILTER]: GA_CATEGORY_FILTER_ACTION,
    [FORMAT_FILTER]: GA_EVENT_TYPE_FILTER_ACTION,
    [PRICE_FILTER]: GA_PRICE_FILTER_ACTION,
    [DATE_FILTER]: GA_DATE_FILTER_ACTION,
    [QUERY_FILTER]: GA_RUN_SEARCH_ACTION,
    [CURRENCY_FILTER]: GA_CURRENCY_FILTER_ACTION,
    [LANGUAGE_FILTER]: GA_LANGUAGE_FILTER_ACTION,
    [SPECIAL_FILTER]: GA_FOLLOWED_ORGANIZERS_FILTER,
};

export const GOOGLE_OPTIMIZE_NULL_EXPERIMENT_ID = 'VMDdMrAiSGGJcy4TVI4fsA';

/****************************** TRACKING CONSTANTS ********************************/

const CITY_BROWSE_EVENT_VIEW_AFFILIATE = 'ebdssbcitybrowse';
const SEARCH_EVENT_VIEW_SEARCH_AFFILIATE = 'ebdssbdestsearch';
const ONLINE_BROWSE_EVENT_VIEW_AFFILIATE = 'ebdssbonlinebrowse';
const ONLINE_SEARCH_EVENT_VIEW_AFFILIATE = 'ebdssbonlinesearch';

export const EVENT_AUTOCOMPLETE_AFFILIATE = 'ebdssbeac';
export const EVENT_AFFILIATES_MAP = {
    [CITY_BROWSE_SECTION]: CITY_BROWSE_EVENT_VIEW_AFFILIATE,
    [SEARCH_SECTION]: SEARCH_EVENT_VIEW_SEARCH_AFFILIATE,
    [ONLINE_BROWSE_SECTION]: ONLINE_BROWSE_EVENT_VIEW_AFFILIATE,
    [ONLINE_SEARCH_SECTION]: ONLINE_SEARCH_EVENT_VIEW_AFFILIATE,
};
